import React, {PropTypes, Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import { range } from './Util';
import { Link } from 'react-router-dom'
import CityImage from './CityImage';

class CityTile extends Component {
  static propTypes = {
    city: PropTypes.object.isRequired,
  };

  render() {
    const city = this.props.city;
    return (
        <article className="col-lg-4 col-md-4 col-sm-4 col-xs-6 banner-box">
          <div>
            <Link to={`/city-${city.slug}`} >
              <figure>
                <CityImage city={city.name} />
              </figure>
              <div className="caption">{city.name}, {city.stateAbbreviation}</div>
            </Link>
          </div>
        </article>
    );
  }
}

const NUM_COLS = 3;
class CityTiles extends Component {
  static propTypes = {
    cities: PropTypes.array.isRequired,
  };

  render() {
    const cityRows = this.cityRows(this.props.cities);
    return (
        <div className="global">
          <div className="container">
            <div className="row">
              <article className="col-lg-12 col-md-12 col-sm-12 categoriesBox">
                <h2><span>Participating Cities</span></h2>
              </article>
              {cityRows}
            </div>
          </div>
        </div>
    );
  }

  cityRows(cities) {
    const numRows = Math.ceil(cities.length / NUM_COLS);
    const subArrays = range(numRows).map( (row) => { return cities.slice(row * NUM_COLS, ((row+1) * NUM_COLS)) });
    return subArrays.map( (subArray, index) => { return this.cityRow(index, subArray) });
  }

  cityRow(rowNum, cities) {
    const cityTiles = cities.map( city => {
      return (
          <CityTile key={"tile-" + city.name} city={city} />
      );
    });
    return (
        <Row key={"row-" + rowNum}>
          {cityTiles}
        </Row>
    );
  }
}

export default CityTiles;


// WEBPACK FOOTER //
// ./src/CityTiles.js